<template>
    <div class="app-container">
        <div id="receive-image" style="display: none;"></div>
        <div id="send-image" style="display: none;"></div>
        <div id="set-image" style="display: none;"></div>
        <div v-if="apiFailed" class="app-error-info">
            <img src="../assets/images/icon_server_down.svg" />
            <div>
                Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
            </div>
        </div>
        <div v-if="str">
            <photo :callback="receivePhoto" :photo="photo" />
        </div>
    </div>
</template>

<style>
    .app-container {
        width: 100%;
        height: 100%;
    }
</style>

<script>
    import Api from '../services/Api'
    import Photo from '@/components/Photo'

    export default {
        components: {
            Photo,
        },
        data() {
            return {
                str: null,
                apiFailed: false,
                photo: null,
                processing: true
            }
        },
        beforeMount: function () {
            this.getStrings()
        },
        methods: {
            getStrings: function () {
                const self = this
                this.apiFailed = false
                Api.getStrings(function (response) {
                    if (response.success) {
                        window.strings = response.data
                        self.str = response.data
                        self.main()
                    } else {
                        self.apiFailed = true
                    }
                })
            },
            main: function () {
                const self = this
                const intervalPromise = setInterval(function () {
                    const photoReceived = document.getElementById('receive-image').getAttribute('image')

                    if (photoReceived) {
                        if (photoReceived != 'no-photo') {
                            self.photo = photoReceived
                        }
                        clearInterval(intervalPromise);
                        self.processing = false;
                    }
                }, 200)
            },
            receivePhoto: function (photo) {
                this.photo = photo
                document.getElementById('send-image').setAttribute('image', this.photo)
                document.getElementById('send-image').click()
            },
        },
    }
</script>